import { styled } from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  height: 1.6rem;
  align-items: center;
  gap: var(--Spacing-0, 0);
  width: calc(100% + 1.8rem);
  margin-left: -1.8rem;
  margin-top: 0.2rem;
`;

export const DescriptionText = styled.p`
  color: var(--Color-Common-Text-Tertiary, #7c899c);
  font-family: var(--font-pretendard);
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
`;

export const FocusText = styled.span`
  color: var(--Color-Common-Text-Interactive-Primary, #0198e9);
  font-family: var(--font-pretendard);
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
`;
